import { forwardRef } from 'react';
import {
  Tabs as MuiTabs,
  TabsProps as MuiTabsProps,
  TabsList as MuiTabsList,
  TabsListProps as MuiTabsListProps,
  TabPanel as MuiTabPanel,
  TabPanelProps as MuiTabPanelProps,
  Tab as TabButton,
  TabProps as MuiTabProps,
} from '@mui/base';
import cx from 'classnames';

import s from './styles.scss';

export interface TabsProps {
  children: MuiTabsProps['children'];
  value?: MuiTabProps['value'];
  defaultValue?: MuiTabsProps['defaultValue'];
  onChange?: MuiTabsProps['onChange'];
}
interface ListProps {
  children: MuiTabsListProps['children'];
}
interface TabProps {
  children: MuiTabProps['children'];
  value: string;
  disabled?: boolean;
}
interface PanelProps {
  children: MuiTabPanelProps['children'];
  value: MuiTabPanelProps['value'];
}

const Tabs = ({
  onChange,
  children,
  value,
  defaultValue,
}: TabsProps): JSX.Element => (
  <MuiTabs
    className={s.tabs}
    value={value}
    defaultValue={defaultValue}
    onChange={onChange}
  >
    {children}
  </MuiTabs>
);

const TabsList = ({ children }: ListProps): JSX.Element => (
  <MuiTabsList className={s.list}>{children}</MuiTabsList>
);

const Tab = forwardRef(
  (
    { children, value, disabled }: TabProps,
    ref: React.Ref<HTMLButtonElement>
  ): JSX.Element => {
    return (
      <TabButton
        className={cx(s.tab, { [s.disabled]: disabled })}
        value={value}
        disabled={disabled}
        ref={ref}
      >
        {children}
      </TabButton>
    );
  }
);

const TabPanel = ({ children, value }: PanelProps): JSX.Element => (
  <MuiTabPanel className={s.panel} value={value}>
    {children}
  </MuiTabPanel>
);

Tabs.List = TabsList;
Tabs.Tab = Tab;
Tabs.Panel = TabPanel;

export { Tabs };
